import type { BubblePointPressurePSIACalculator } from "../../d";

export const bubblePointPressurePSIACalculator: BubblePointPressurePSIACalculator =
  params => {
    const {
      oilAPI,
      temperatureF,
      gasSpecificGravity,
      solutionGasRsoAtReservoir
    } = params;

    // D98: =(7.916*10**-4)*(D7**1.541)-(4.561*10**-5)*D4**1.3911
    const x =
      7.916 * 10 ** -4 * oilAPI ** 1.541 -
      4.561 * 10 ** -5 * temperatureF ** 1.3911;

    // D100: =((112.727*(J15**0.577421))/((D8**0.8439)*10**D98))-1391.051
    const bubblePointPressurePSIA =
      (112.727 * solutionGasRsoAtReservoir ** 0.577421) /
        (gasSpecificGravity ** 0.8439 * 10 ** x) -
      1391.051;

    return {
      bubblePointPressurePSIA,
      x,
      solutionGasRsoAtReservoir
    };
  };
